<app-navigation></app-navigation>
<mat-card class="card">
  <mat-card-content>
    <h1>Passwort ändern</h1>
    <form [formGroup]="form" class="form">
      <!-- <mat-form-field class="input-section"> -->
      <!-- <mat-label>Altes Password</mat-label>
        <input type="password" matInput formControlName="oldPassword" autocomplete="current-password" />
        @if (!form.controls.oldPassword.hasError('required')) {
          <mat-error>Please enter a password</mat-error>
        }
        @if (form.controls.oldPassword.hasError('required')) {
          <mat-error>Password is <strong>required</strong></mat-error>
        }
      </mat-form-field> -->
      <mat-form-field class="input-section">
        <mat-label>Neues Password</mat-label>
        <input type="password" matInput formControlName="password1" autocomplete="new-password" />
        @if (!form.controls.password1.hasError('required')) {
          <mat-error>Please enter a password</mat-error>
        }
        @if (form.controls.password1.hasError('required')) {
          <mat-error>Password is <strong>required</strong></mat-error>
        }
      </mat-form-field>
      <mat-form-field class="input-section">
        <mat-label>Neues Password wiederholen</mat-label>
        <input type="password" matInput formControlName="password2" autocomplete="new-password" />
        @if (!form.controls.password2.hasError('required')) {
          <mat-error>Please enter a password</mat-error>
        }
        @if (form.controls.password2.hasError('required')) {
          <mat-error>Password is <strong>required</strong></mat-error>
        }
      </mat-form-field>
      @if ($authError() !== '') {
        <mat-error>{{ $authError() }}</mat-error>
        <br />
      }
    </form>

    <div class="buttons">
      <button mat-flat-button color="secondary" (click)="location.back()">Abbrechen</button>
      @if (showLogin) {
        <button mat-flat-button color="primary" (click)="gotoLogin()">zum Login</button>
      }
      @if (showPassordButton) {
        <button mat-flat-button color="primary" (click)="onChangePassword()">Passwort ändern</button>
      }
    </div>
  </mat-card-content>
</mat-card>
